module.exports = __webpack_public_path__ + "img/gear-big.c0856742.png";